import React, { useEffect, useRef } from "react";
import { Sort } from "../Sort/Sort";
import { FiltersProps } from "./Filters";
import { FiltersPanel } from "./FiltersPanel";
// import SelectedFilters from "@appbaseio/reactivesearch/lib/components/basic/SelectedFilters";
import { ClearAll, FiltersSelected, FiltersSelectedProps } from "@usereactify/search";
import { useHideHelpBtn } from "../../hooks/useHideHelpBtn";
import { useOnClickOutside } from "../../hooks/useOnClickOutside";
import { ClearAllButton } from "./ClearFiltersBtn";

export const FiltersMobile: React.FC<FiltersProps> = (props) => {
  const { isOpen, setIsOpen, btnText } = props;

  // const toggleDropdown = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  // const { overlayHeight, overlayTop } = useCalculateOverlay();
  const { hideHelpBtn, showHelpBtn } = useHideHelpBtn();
  // const toggleMenu = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  useEffect(() => {
    isOpen ? hideHelpBtn() : showHelpBtn();
  }, [isOpen]);

  const ref = useRef(null);
  useOnClickOutside(ref, () => setIsOpen(false));

  return (
    <div className="relative sort-m dropdown-box w-full">
      <button className="mb-0 collection-filter__btn text-link" onClick={() => setIsOpen(true)}>
        {isOpen ? (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.04249 9.00044L3.2697 13.7732L4.22429 14.7278L8.99709 9.95504L13.7701 14.728L14.7247 13.7734L9.95168 9.00044L14.7248 4.2273L13.7702 3.27271L8.99709 8.04585L4.22413 3.27289L3.26953 4.22748L8.04249 9.00044Z"
              fill="#2D2926"
            />
          </svg>
        ) : (
          <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.4383 2.99995C11.8082 1.56233 13.1133 0.5 14.6666 0.5C16.2197 0.5 17.5248 1.56233 17.8948 2.99995H19.6659C20.1265 2.99995 20.4998 3.36976 20.4998 3.83321C20.4998 4.29345 20.1269 4.66662 19.6659 4.66662H17.8948C17.5248 6.10424 16.2197 7.16657 14.6666 7.16657C13.1133 7.16657 11.8083 6.10424 11.4383 4.66662H1.33384C0.873313 4.66662 0.5 4.29667 0.5 3.83321C0.5 3.37297 0.872885 2.99995 1.33384 2.99995H11.4383ZM3.10523 11.333C3.47519 9.89537 4.78026 8.83303 6.33341 8.83303C7.88666 8.83303 9.19174 9.89537 9.56173 11.333H19.6662C20.1267 11.333 20.5 11.7029 20.5 12.1664C20.5 12.6266 20.1271 12.9997 19.6662 12.9997H9.56173C9.19178 14.4373 7.8867 15.4996 6.33341 15.4996C4.7803 15.4996 3.47522 14.4373 3.10523 12.9997H1.33405C0.873528 12.9997 0.500214 12.6298 0.500214 12.1664C0.500214 11.7062 0.873099 11.333 1.33405 11.333H3.10523ZM6.33341 13.8329C7.25385 13.8329 8.00009 13.0868 8.00009 12.1664C8.00009 11.2459 7.25385 10.4997 6.33341 10.4997C5.41297 10.4997 4.66688 11.2459 4.66688 12.1664C4.66688 13.0868 5.41297 13.8329 6.33341 13.8329ZM14.6668 5.49989C15.5872 5.49989 16.3333 4.75366 16.3333 3.83321C16.3333 2.91277 15.5872 2.16668 14.6668 2.16668C13.7464 2.16668 13.0001 2.91277 13.0001 3.83321C13.0001 4.75366 13.7464 5.49989 14.6668 5.49989Z"
              fill="black"
            />
          </svg>
        )}
        {btnText}
      </button>

      {/* {isOpen && (...)} */}
      <nav className="mobile-filters">
        <div
          className="filter-mobile-fixed-container"
          style={{
            // display: isOpen ? "block" : "none",
            pointerEvents: isOpen ? "auto" : "none",
            visibility: isOpen ? "visible" : "hidden",
            opacity: isOpen ? 1 : 0,
          }}
        >
          <div
            id="CollectionInlineFilterWrap"
            className="filter-wrapper filter-wrapper-custom-mobile"
            ref={ref}
            style={{
              transform: isOpen ? "translateX(0)" : "translateX(100%)",
            }}
          >
            {/* <h2 className="text-center text-2xl mb-8">{titleText}</h2> */}
            <div className="filter-wrapper-custom-mobile-header">
              <StoreLogo />
              {/* Close button: */}
              <button className="filter-mobile-close-button" onClick={() => setIsOpen(false)}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.04249 9.00044L3.2697 13.7732L4.22429 14.7278L8.99709 9.95504L13.7701 14.728L14.7247 13.7734L9.95168 9.00044L14.7248 4.2273L13.7702 3.27271L8.99709 8.04585L4.22413 3.27289L3.26953 4.22748L8.04249 9.00044Z"
                    fill="#2D2926"
                  />
                </svg>
              </button>
            </div>

            <div className="filter-wrapper-custom-mobile-inner-content">
              <FiltersSelected render={SelectedFilters} />
              <Sort />
              {/* <Filters
                renderFilterList={(props) => <FiltersPanel isDropdown={true} filter={props.filter} />}
                renderFilterSlider={(props) => <FiltersPanel isDropdown={true} filter={props.filter} />}
                renderFilterRange={(props) => <FiltersPanel isDropdown={true} filter={props.filter} />}
              /> */}
              {props.filters?.map((filter) => (
                <>
                  <FiltersPanel isDropdown={true} filter={filter} />
                </>
              ))}
            </div>

            <div className="filter-wrapper-custom-mobile-footer">
              <button className="btn btn-primary" onClick={() => setIsOpen(false)} style={{ padding: "20px 15px" }}>
                Apply
              </button>
            </div>
          </div>
          {/* <div className="pt-10 grid grid-cols-2 gap-4 justify-between">
            <ClearFiltersBtn />
            <button className="btn btn-primary" onClick={toggleDropdown}>
              Apply
            </button>
          </div> */}
        </div>
      </nav>
    </div>
  );
};

type MyFiltersSelectedProps = React.ComponentProps<NonNullable<FiltersSelectedProps["render"]>>;

export const SelectedFilters: React.FC<MyFiltersSelectedProps> = (props) => {
  return (
    <>
      <ul className="no-bullets tag-list tag-list--active-tags selected-filters-ul">
        {props.selectedFilters?.map((selectedFilter) => (
          <li
            className="tag tag--remove label"
            style={{
              marginBottom: "13px", // the label have mb: 0px, so we need to override it
            }}
          >
            <button
              key={selectedFilter.key}
              className="btn btn--small js-no-transition"
              style={{ marginBottom: 0 }}
              onClick={() => props.handleRemove(selectedFilter.key)}
            >
              <svg width="8" height="8" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.94334 8L0 1.05665L1.05665 0L8 6.94334L14.9433 0L16 1.05665L9.05665 8L16 14.9433L14.9433 16L8 9.05665L1.05665 16L0 14.9433L6.94334 8Z"
                  fill="#ffffff"
                />
              </svg>
              {/* {selectedFilter.label}: {selectedFilter.value?.join?.(", ") ?? selectedFilter.value} */}
              {selectedFilter.label}:{" "}
              {Array.isArray(selectedFilter.value)
                ? selectedFilter.value.join(", ")
                : typeof selectedFilter.value === "object"
                ? `${selectedFilter.value.label} (${selectedFilter.value.start}-${selectedFilter.value.end})`
                : selectedFilter.value}
            </button>
          </li>
        ))}
        <li className="tag tag--remove small clear-filters" style={{ marginBottom: 0 }}>
          <ClearAll render={ClearAllButton} />
        </li>
      </ul>
    </>
  );
};

const StoreLogo: React.FC = () => (
  <a
    href="/"
    style={{
      display: "inline-block",
    }}
  >
    <svg width="153" height="30" viewBox="0 0 153 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1107_91_999)">
        <rect width="153" height="30" fill="white"></rect>
        <path
          d="M16.1726 17.8216H12.0764L6.75449 11.8705H3.44261V17.8216H0V0C2.89789 0 5.79034 0.026544 8.68823 0.026544C12.9915 0.053088 15.263 2.85082 15.263 5.92462C15.263 8.36666 14.1136 10.8299 10.6438 11.5201L16.1726 17.5987V17.8269V17.8216ZM3.44261 3.15342V8.84976H8.68823C10.878 8.84976 11.8204 7.42701 11.8204 6.00425C11.8204 4.58149 10.8562 3.15873 8.68823 3.15873H3.44261V3.15342Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M20.7143 12.6612C20.9213 14.2113 22.3049 15.3315 24.5491 15.3315C25.7203 15.3315 27.2618 14.8962 27.9917 14.1636L30.029 16.1225C28.6726 17.4975 26.4556 18.1558 24.5001 18.1558C20.0661 18.1558 17.4297 15.4855 17.4297 11.4667C17.4297 7.44794 20.0879 4.90503 24.2659 4.90503C28.4439 4.90503 31.2546 7.49572 30.7643 12.6612H20.7198H20.7143ZM27.7085 10.0917C27.5015 8.46192 26.1942 7.64968 24.3694 7.64968C22.6481 7.64968 21.2373 8.46192 20.7688 10.0917H27.7085Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M42.161 17.8214V11.111C42.161 9.46001 41.2731 7.95762 39.5246 7.95762C37.776 7.95762 36.7847 9.46001 36.7847 11.111V17.8214H33.6035V5.26075H36.5504L36.7847 6.78438C37.4656 5.51558 38.9526 5.05371 40.1782 5.05371C41.7198 5.05371 43.2559 5.66422 43.9858 7.39489C45.1352 5.61644 46.6222 5.1068 48.2891 5.1068C51.9387 5.1068 53.7417 7.29402 53.7417 11.058V17.8214H50.5605V11.058C50.5605 9.40692 49.8579 8.0054 48.1366 8.0054C46.4153 8.0054 45.3422 9.4547 45.3422 11.1057V17.8161H42.161V17.8214Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M67.835 5.28731H70.8854V17.8214H67.884L67.726 15.9898C66.9961 17.4657 64.9861 18.1771 63.5535 18.2036C59.7459 18.2302 56.9243 15.9421 56.9243 11.5411C56.9243 7.14008 59.8712 4.95817 63.6298 4.9794C65.3511 4.9794 66.9961 5.7651 67.726 7.01267L67.8295 5.282L67.835 5.28731ZM60.1109 11.5411C60.1109 13.93 61.805 15.3528 63.9185 15.3528C68.9299 15.3528 68.9299 7.75059 63.9185 7.75059C61.805 7.75059 60.1109 9.14681 60.1109 11.5411Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M77.1749 5.28764L77.4092 6.73694C78.4006 5.18677 79.7297 4.9585 81.037 4.9585C82.3443 4.9585 83.6462 5.46814 84.3489 6.15298L82.9163 8.84984C82.2626 8.31365 81.6634 8.0376 80.6176 8.0376C78.9453 8.0376 77.4092 8.90293 77.4092 11.2176V17.827H74.228V5.28764H77.1749Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M89.3066 0.0529785V10.3255L93.6371 5.29276H97.4447V5.46795L92.1991 11.1908L98.1746 17.5985V17.8268H94.3398L89.3066 12.157V17.8268H86.1255V0.0529785H89.3066Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M110.49 5.28731H113.541V17.8214H110.539L110.381 15.9898C109.651 17.4657 107.641 18.1771 106.209 18.2036C102.401 18.2302 99.5796 15.9421 99.5796 11.5411C99.5796 7.14008 102.527 4.95817 106.285 4.9794C108.006 4.9794 109.651 5.7651 110.381 7.01267L110.485 5.282L110.49 5.28731ZM102.766 11.5411C102.766 13.93 104.46 15.3528 106.574 15.3528C111.585 15.3528 111.585 7.75059 106.574 7.75059C104.46 7.75059 102.766 9.14681 102.766 11.5411Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M119.81 0.0529785V6.99157C120.567 5.69623 122.681 4.98485 124.037 4.98485C127.795 4.98485 130.584 7.22516 130.584 11.5465C130.584 15.8679 127.741 18.1082 123.955 18.1082C122.392 18.1082 120.796 17.5985 119.804 16.1015L119.597 17.8321H116.623V0.0529785H119.804H119.81ZM120.017 11.5465C120.017 13.8081 121.738 15.2361 123.748 15.2361C125.758 15.2361 127.398 13.7337 127.398 11.5465C127.398 9.3593 125.78 7.88345 123.748 7.88345C121.716 7.88345 120.017 9.3593 120.017 11.5465Z"
          fill="#1A1A1A"
        ></path>
        <path d="M136.741 0.0529785V17.8215H133.582V0.0529785H136.741Z" fill="#1A1A1A"></path>
        <path
          d="M142.895 12.6612C143.102 14.2113 144.486 15.3315 146.73 15.3315C147.901 15.3315 149.442 14.8962 150.172 14.1636L152.21 16.1225C150.853 17.4975 148.636 18.1558 146.681 18.1558C142.247 18.1558 139.61 15.4855 139.61 11.4667C139.61 7.44794 142.269 4.90503 146.447 4.90503C150.625 4.90503 153.435 7.49572 152.945 12.6612H142.9H142.895ZM149.889 10.0917C149.682 8.46192 148.375 7.64968 146.55 7.64968C144.829 7.64968 143.418 8.46192 142.949 10.0917H149.889Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M33.6035 25.0573C33.6035 23.6929 34.6058 22.8223 35.8477 22.8223C37.0897 22.8223 38.092 23.6929 38.092 25.0573C38.092 26.4216 37.0897 27.2604 35.8477 27.2604C34.6058 27.2604 33.6035 26.4269 33.6035 25.0573ZM37.6562 25.0573C37.6562 23.9424 36.8446 23.2204 35.8423 23.2204C34.84 23.2204 34.0284 23.9424 34.0284 25.0573C34.0284 26.1721 34.84 26.841 35.8423 26.841C36.8446 26.841 37.6562 26.1721 37.6562 25.0573Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M43.4136 27.1967V26.4216C43.0759 27.0109 42.4603 27.2551 41.8394 27.2657C40.6573 27.2657 39.8457 26.5597 39.8457 25.3652V22.886H40.2815V25.3599C40.2815 26.3367 40.897 26.857 41.8557 26.8463C42.7654 26.8357 43.4027 26.1668 43.4027 25.2803V22.886H43.8385V27.1967H43.4082H43.4136Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M46.7964 21.6016V22.8969H48.2944V23.2526H46.7964V25.8751C46.7964 26.4591 46.9217 26.8679 47.6081 26.8679C47.8205 26.8679 48.0656 26.7989 48.289 26.6927L48.4415 27.0431C48.1637 27.1758 47.8859 27.2607 47.6081 27.2607C46.6712 27.2607 46.3661 26.7192 46.3661 25.8751V23.2526H45.4292V22.8969H46.3661V21.644L46.7964 21.6016Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M54.085 21.1023V27.1968H53.6547V26.2465C53.2897 26.8995 52.5652 27.2658 51.8135 27.2658C50.5825 27.2658 49.6074 26.4748 49.6074 25.0467C49.6074 23.6187 50.5879 22.8277 51.8244 22.8277C52.5816 22.8277 53.2952 23.1409 53.6547 23.8363V21.1023H54.085ZM50.0377 25.0467C50.0377 26.2412 50.8494 26.8464 51.8408 26.8464C52.8321 26.8464 53.6438 26.1085 53.6438 25.0361C53.6438 23.9637 52.8594 23.2311 51.8408 23.2311C50.8221 23.2311 50.0377 23.831 50.0377 25.0414V25.0467Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M55.9248 25.0573C55.9248 23.6929 56.9271 22.8223 58.169 22.8223C59.411 22.8223 60.4133 23.6929 60.4133 25.0573C60.4133 26.4216 59.411 27.2604 58.169 27.2604C56.9271 27.2604 55.9248 26.4269 55.9248 25.0573ZM59.9775 25.0573C59.9775 23.9424 59.1659 23.2204 58.1636 23.2204C57.1613 23.2204 56.3497 23.9424 56.3497 25.0573C56.3497 26.1721 57.1613 26.841 58.1636 26.841C59.1659 26.841 59.9775 26.1721 59.9775 25.0573Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M61.9941 25.0573C61.9941 23.6929 62.9964 22.8223 64.2384 22.8223C65.4803 22.8223 66.4826 23.6929 66.4826 25.0573C66.4826 26.4216 65.4803 27.2604 64.2384 27.2604C62.9964 27.2604 61.9941 26.4269 61.9941 25.0573ZM66.0523 25.0573C66.0523 23.9424 65.2407 23.2204 64.2384 23.2204C63.2361 23.2204 62.4245 23.9424 62.4245 25.0573C62.4245 26.1721 63.2361 26.841 64.2384 26.841C65.2407 26.841 66.0523 26.1721 66.0523 25.0573Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M68.7005 22.8971L68.7222 23.6615C69.0001 23.0776 69.621 22.8546 70.1875 22.8546C70.5198 22.844 70.8412 22.9342 71.1353 23.1041L70.9392 23.4545C70.705 23.3165 70.449 23.2528 70.1875 23.2528C69.365 23.2634 68.7331 23.9057 68.7331 24.6914V27.1972H68.2974V22.8971H68.7059H68.7005Z"
          fill="#1A1A1A"
        ></path>
        <path d="M76.0271 21.1023V27.1968H75.5913V21.1023H76.0271Z" fill="#1A1A1A"></path>
        <path
          d="M78.629 21.4954C78.629 21.9467 77.9209 21.9467 77.9209 21.4954C77.9209 21.0442 78.629 21.0442 78.629 21.4954ZM78.0462 22.881V27.2024H78.482V22.881H78.0462Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M80.0791 22.8967H80.5639L82.1708 26.7031L83.7777 22.8967H84.2625L82.4159 27.1969H81.9311L80.0846 22.8967H80.0791Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M86.3864 21.4952C86.3864 21.9464 85.6782 21.9464 85.6782 21.4952C85.6782 21.0439 86.3864 21.0439 86.3864 21.4952ZM85.809 22.8808V27.2021H86.2447V22.8808H85.809Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M88.7174 22.8968V23.6612C89.0551 23.0667 89.6706 22.8278 90.2916 22.8171C91.4682 22.8171 92.2853 23.5232 92.2853 24.7177V27.1969H91.8495V24.723C91.8495 23.7462 91.234 23.2259 90.2752 23.2312C89.3601 23.2418 88.7283 23.9108 88.7283 24.7973V27.1916H88.2925V22.8915H88.7228L88.7174 22.8968Z"
          fill="#1A1A1A"
        ></path>
        <path
          d="M97.7553 22.7214L98.044 22.9656L97.6137 23.454C97.9296 23.7832 98.1584 24.2185 98.1584 24.9193C98.1584 25.6678 97.7008 26.427 96.9709 26.7455C97.7498 27.0163 98.1747 27.5471 98.1747 28.2851C98.1747 29.4424 97.2433 29.9998 96.0776 29.9998C94.9119 29.9998 93.9858 29.3734 93.9858 28.2851H94.4216C94.4216 29.1663 95.1897 29.5804 96.0721 29.5804C96.9545 29.5804 97.7444 29.1982 97.7444 28.2851C97.7444 27.3719 96.8946 26.995 96.0721 26.995C94.792 26.995 93.9967 26.066 93.9967 24.914C93.9967 23.5708 94.9282 22.817 96.0721 22.817C96.5188 22.817 96.9818 22.9763 97.3195 23.2098L97.7498 22.7214H97.7553ZM94.4434 24.914C94.4434 25.8005 95.0698 26.565 96.0776 26.565C96.9872 26.565 97.728 25.8005 97.728 24.914C97.728 23.8257 96.9872 23.2417 96.0776 23.2417C95.1679 23.2417 94.4434 23.7885 94.4434 24.914Z"
          fill="#1A1A1A"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1107_91_999">
          <rect width="153" height="30" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  </a>
);
